/**
 * Focuses element on click.
 * 
 * By default safari does not focus buttons on click.
 * https://developer.mozilla.org/en-US/docs/Web/HTML/Element/button#clicking_and_focus
 * 
 * It is used in buttons where the focus or focus-within selector
 * changes the visibility of menu.
 * @example
 * <button v-focus-click>
 */
export const vFocusClick = {
  mounted: (el) => {
    el.addEventListener("click", el.focus);
  },
  beforeUnmount: (el) => {
    el.removeEventListener("click", el.focus);
  },
};
